import { useEffect, useState } from 'react';

// Standalone /qr page — used as a backup display option if the admin modal
// QR isn't suitable (e.g. you want a dedicated browser tab on the projector
// without the admin chrome). The modal in /admin is the primary path.
export function QrPage() {
  const [origin, setOrigin] = useState('');
  useEffect(() => { setOrigin(window.location.origin); }, []);
  const url = origin ? `${origin}/` : '';
  const qrSrc = origin
    ? `https://api.qrserver.com/v1/create-qr-code/?size=720x720&margin=24&qzone=4&data=${encodeURIComponent(url)}&color=19355C&bgcolor=FFFFFF`
    : '';

  return (
    <main className="min-h-full grid place-items-center p-10 bg-tatweer-light">
      <div className="text-center max-w-2xl bg-white rounded-3xl shadow-card-lg ring-1 ring-tatweer-line p-10">
        <div className="flex items-center justify-center gap-3 pb-5 border-b border-tatweer-line mb-6">
          <div className="rounded-lg bg-tatweer-navy p-2.5">
            <img src="/brand/tatweer-white.svg" alt="Tatweer" className="h-10 w-auto" />
          </div>
          <div className="text-start">
            <div className="text-[10px] uppercase tracking-[0.3em] text-tatweer-muted">Scan to join</div>
            <div className="text-2xl font-bold text-tatweer-navy">مرصد اعتماد</div>
          </div>
        </div>

        {qrSrc ? (
          <img
            src={qrSrc}
            alt="QR code to join the workshop"
            className="mx-auto rounded-2xl ring-1 ring-tatweer-line p-2"
            style={{ width: 'min(72vmin, 720px)', height: 'min(72vmin, 720px)' }}
          />
        ) : (
          <div className="bg-tatweer-light rounded-2xl mx-auto" style={{ width: 'min(72vmin, 720px)', height: 'min(72vmin, 720px)' }} />
        )}

        <div className="mt-6 text-2xl font-mono text-tatweer-navy break-all">{url}</div>
        <div className="mt-2 text-sm text-tatweer-body-soft">Marsad Etimad · Tatweer AI</div>
      </div>
    </main>
  );
}
